import React, { useReducer } from 'react'
import boardContext from './board-context'
import { BOARD_ACTIONS, TOOL_ACTION_TYPES, TOOL_ITEMS } from '../constants';
import { useCallback } from 'react';
import { getSvgPathFromStroke,isPointNearElement,} from "../utils/element";
import getStroke from "perfect-freehand";
import { createRoughElement } from '../utils/element';

// rough generator is used to create sketch-like shapes (it does not draw directly)


const boardReducer= (state,action) =>{
 switch (action.type) {

  // if we change the tool
    case BOARD_ACTIONS.CHANGE_TOOL:{
 return{
       ...state,
            activeToolItem: action.payload.tool,// keep rest the state same and return the tool we clicked on throught action 
            // only tool changes, drawings and other state remain the same
        }
    }
    
        case BOARD_ACTIONS.CHANGE_ACTION_TYPE:
      return {
        ...state,
        toolActionType: action.payload.actionType,
      };
       

  // on draw down
    case BOARD_ACTIONS.DRAW_DOWN: {
       if (state.activeToolItem === TOOL_ITEMS.ERASER) {
    return state;
  }
  const { clientX, clientY,stroke,fill,size } = action.payload;// extract the x,y axis we click on 
// create rough element of this index , with these axis and type of tool
const newElement = createRoughElement(
state.elements.length,
clientX,
clientY, 
clientX,
clientY,
{type: state.activeToolItem,stroke,fill,size}
  );
  const prevElements = state.elements;
       return {
        ...state,
        toolActionType:
          state.activeToolItem === TOOL_ITEMS.TEXT
            ? TOOL_ACTION_TYPES.WRITING
            : TOOL_ACTION_TYPES.DRAWING,
        elements: [...prevElements, newElement],
      };
}

//on moving the mouse 
case BOARD_ACTIONS.DRAW_MOVE: {
    if (state.elements.length === 0) return state;
      const { clientX, clientY } = action.payload;
      const newElements = [...state.elements];
      const index = state.elements.length - 1;
      const { type } = newElements[index];
      switch (type) {
        case TOOL_ITEMS.LINE:
        case TOOL_ITEMS.RECTANGLE:
        case TOOL_ITEMS.CIRCLE:
        case TOOL_ITEMS.ARROW:
          const { x1, y1, stroke, fill, size } = newElements[index];
          const newElement = createRoughElement(index, x1, y1, clientX, clientY, {
            type: state.activeToolItem,
            stroke,
            fill,
            size,
          });
          newElements[index] = newElement;
          return {
            ...state,
            elements: newElements,
          };
        case TOOL_ITEMS.BRUSH:
          newElements[index].points = [
            ...newElements[index].points,
            { x: clientX, y: clientY },
          ];
          newElements[index].path = new Path2D(
            getSvgPathFromStroke(getStroke(newElements[index].points))
          );
          return {
            ...state,
            elements: newElements,
          };
        default:
          throw new Error("Type not recognized");
      }
    }

case BOARD_ACTIONS.DRAW_UP:{
   if (state.toolActionType !== TOOL_ACTION_TYPES.DRAWING) return state;
  const elementsCopy = [...state.elements];
  const newHistory = state.history.slice(0,state.index+1);
  newHistory.push(elementsCopy);
  return {
    ...state,
    history: newHistory,
    index: state.index+1,
  };
}
    case BOARD_ACTIONS.ERASE: {
      const { clientX, clientY } = action.payload;
      let newElements = [...state.elements];
      newElements = newElements.filter((element) => {
        return !isPointNearElement(element, clientX, clientY);
      });
      const newHistory = state.history.slice(0, state.index + 1);
      newHistory.push(newElements);
      return {
        ...state,
        elements: newElements,
        history: newHistory,
        index: state.index + 1,
      };
    }

    case BOARD_ACTIONS.CHANGE_TEXT: {
  const index = state.elements.length - 1;
  const newElements = [...state.elements];

  newElements[index] = {
    ...newElements[index],
    text: action.payload.text,
  };
const newHistory = state.history.slice(0,state.index+1);
  newHistory.push(newElements);
  return {
    ...state,
    toolActionType: TOOL_ACTION_TYPES.NONE,
    elements: newElements,
    history: newHistory,
    index: state.index+1,
  };
} 
 case BOARD_ACTIONS.UNDO: {
      if (state.index <= 0) return state;
      return {
        ...state,
        elements: state.history[state.index - 1],
        index: state.index - 1,
      };
    }
    case BOARD_ACTIONS.REDO: {
      if (state.index >= state.history.length - 1) return state;
      return {
        ...state,
        elements: state.history[state.index + 1],
        index: state.index + 1,
      };
    }

    default:
        return state;
 }
}

//inital state of board
const initialBoardState= {
    activeToolItem: TOOL_ITEMS.BRUSH,
    // default tool when board loads

    toolActionType: TOOL_ACTION_TYPES.NONE,
    // no action happening initially

    elements:[],
    // stores all drawn elements
    history:[[]],
index:0,
}



// use reducer 
const BoardProvider = ({children}) => {
    const [boardState, dispatchBoardAction]= useReducer(boardReducer, initialBoardState);
//   const [activeToolItem, setActiveToolItem] = useState(TOOL_ITEMS.LINE);  
// useReducer is used instead of useState for complex logic

 
// dispatch functions for every action
const changeToolHandler = (tool) =>{
   dispatchBoardAction({
      type : BOARD_ACTIONS.CHANGE_TOOL, 
      payload:{
        tool,
      }
      // sends selected tool to reducer
   });
  };

  const boardMouseDownHandler= (event, toolboxState)=>{
   if(boardState.toolActionType===TOOL_ACTION_TYPES.WRITING) return;
    const {clientX, clientY}= event;
    // mouse position when pressed

 if (boardState.activeToolItem === TOOL_ITEMS.ERASER) {
      dispatchBoardAction({
        type: BOARD_ACTIONS.CHANGE_ACTION_TYPE,
        payload: {
          actionType: TOOL_ACTION_TYPES.ERASING,
        },
      });
      return;
    }
    dispatchBoardAction({
        type:BOARD_ACTIONS.DRAW_DOWN,
        payload:{
 clientX,
clientY,
stroke: toolboxState[boardState.activeToolItem]?.stroke,
fill : toolboxState[boardState.activeToolItem]?.fill,
size:toolboxState[boardState.activeToolItem]?.size,
        }
        // starts drawing at this point
    })
  }

  const boardMouseMoveHandler= (event)=>{
    if(boardState.toolActionType===TOOL_ACTION_TYPES.WRITING) return;
 const {clientX, clientY}= event;
  // mouse position while moving
  if(boardState.toolActionType===TOOL_ACTION_TYPES.DRAWING){
     dispatchBoardAction({
        type: BOARD_ACTIONS.DRAW_MOVE,
        payload:{
clientX,
clientY
        }
        // updates current shape while dragging
    });
  }
  else if(boardState.toolActionType===TOOL_ACTION_TYPES.ERASING){
 dispatchBoardAction({
        type: BOARD_ACTIONS.ERASE,
        payload:{
clientX,
clientY,
        }
    
    });
  }
   
  };

   const boardMouseUpHandler= ()=>{
  if(boardState.toolActionType===TOOL_ACTION_TYPES.WRITING) return;
 if(boardState.toolActionType===TOOL_ACTION_TYPES.DRAWING){
  dispatchBoardAction({
    type: BOARD_ACTIONS.DRAW_UP,

  });
 }
    dispatchBoardAction({
        type:BOARD_ACTIONS.CHANGE_ACTION_TYPE,
        // stops drawing when mouse is released
        payload:{
          actionType: TOOL_ACTION_TYPES.NONE,
        }
    })
  }

const textAreaBlurHandler=(text)=>{
dispatchBoardAction({
type: BOARD_ACTIONS.CHANGE_TEXT,
payload:{
  text,
},
});
};
  const boardUndoHandler = useCallback(() => {
    dispatchBoardAction({
      type: BOARD_ACTIONS.UNDO,
    });
  }, []);

  const boardRedoHandler = useCallback(() => {
    dispatchBoardAction({
      type: BOARD_ACTIONS.REDO,
    });
  }, []);
  //context value to pass down to other files
  const boardContextValue = {
    activeToolItem: boardState.activeToolItem,
    // currently selected tool

    elements : boardState.elements,
    // all drawn elements

    toolActionType: boardState.toolActionType,
    // tells whether drawing is happening or not

    changeToolHandler,
    boardMouseDownHandler,
    boardMouseMoveHandler,
    boardMouseUpHandler,
    textAreaBlurHandler,
    undo: boardUndoHandler,
    redo: boardRedoHandler,
    // functions used by board and toolbox components
  };


 
 // return the provider 
  return (
   <boardContext.Provider
   value =
    {boardContextValue}>
    {children}
    {/* all child components can access board state */}

   </boardContext.Provider>
  );
};

export default BoardProvider
